import { V1_SET_DEPARTURE_AIRPORT } from '../../actions/search/v1setDepartureAirport'
import { V1_SET_ARRIVAL_AIRPORT } from '../../actions/search/v1setArrivalAirport'
import { V1_SET_DEPARTURE_AIRPORT_SEARCH } from '../../actions/search/v1setDepartureAirportSearch'
import { V1_SET_ARRIVAL_AIRPORT_SEARCH } from '../../actions/search/v1setArrivalAirportSearch'
import { V1_SET_DEPARTURE_DATE } from '../../actions/search/v1setDepartureDate'
import { V1_SET_RETURN_DATE } from '../../actions/search/v1setReturnDate'
import { V1_SET_SEARCH } from '../../actions/search/v1setSearch'

const initialState = {
  departureAirport: '',
  arrivalAirport: '',
  departureAirportSearch: '',
  arrivalAirportSearch: '',
  departureDate: '',
  returnDate: '',
}

/*
 * FIXME: Rewrite how the search form currently works.
 * It seems to complicated for its own good and it causing
 * alot of bugs in Transpartner.
 *
 * The change currently made it to support sending flight codes
 * directly that are not in our list (like BVJ).
 */
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_SET_DEPARTURE_AIRPORT:
      return {
        ...state,
        departureAirport: action.data,
      }
    case V1_SET_ARRIVAL_AIRPORT:
      return {
        ...state,
        arrivalAirport: action.data,
      }
    case V1_SET_DEPARTURE_AIRPORT_SEARCH:
      return {
        ...state,
        departureAirport: action.data,
        departureAirportSearch: action.data,
      }
    case V1_SET_ARRIVAL_AIRPORT_SEARCH:
      return {
        ...state,
        arrivalAirport: action.data,
        arrivalAirportSearch: action.data,
      }
    case V1_SET_DEPARTURE_DATE:
      return {
        ...state,
        departureDate: action.data,
      }
    case V1_SET_RETURN_DATE:
      return {
        ...state,
        returnDate: action.data,
      }
    case V1_SET_SEARCH:
      return {
        ...state,
        ...action.data,
      }
    default:
      return state
  }
}
